import AdminDeleteButton from '../../common/AdminDeleteButton';
import React from 'react';
import { Link, withRouter } from 'react-router-dom/cjs/react-router-dom.min';
import Paginations from '../../common/paginations';
import constant from '../../../constant';

const CategoryList = ({ data, setCurrentPage, limit, onChangeVisibility }) => {
    const { categories, total, page } = data
    return (
        <>
            <div className="table-responsive">
                <table className="table align-middle table-hover">
                    <thead className="table-light">
                        <tr>
                            <th>#</th>
                            <th>Category Name</th>
                            <th>Category Code</th>
                            <th>Status</th>
                            <th>Modified By</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {categories?.length > 0 ? (
                            categories.map((item, index) => (
                                <tr key={index}>
                                    <td>
                                        <div className="avatar-xs">
                                            <span className="avatar-title rounded-circle bg-light text-primary">
                                                {item.CATEGORY_NAME?.charAt(0).toUpperCase()}
                                            </span>
                                        </div>
                                    </td>
                                    <td>{item.CATEGORY_NAME}</td>
                                    <td>{item.CATEGORY_CODE}</td>
                                    <td>
                                        <span
                                            className={`badge rounded-pill ${item.IS_ACTIVE ? 'bg-success' : 'bg-secondary'
                                                }`}
                                        >
                                            {item.IS_ACTIVE ? 'Active' : 'Inactive'}
                                        </span>
                                    </td>
                                    <td>{item.MODIFIED_BY_NAME || '-'}</td>
                                    <td>
                                        <ul className="list-inline font-size-20 contact-links mb-0">
                                            <li className="list-inline-item px-2">
                                                <Link
                                                    to={{
                                                        pathname: constant.Authedcomponent.editScheduleCategoryMasterData.url,
                                                        state: {
                                                            data: btoa(JSON.stringify(item)),
                                                            page: page,
                                                        },
                                                    }}
                                                    title="Edit"
                                                >
                                                    <i className="bx bx-select-multiple"></i>
                                                </Link>
                                            </li>
                                            <li className="list-inline-item px-2">
                                                <a
                                                    href="javascript:void(0);"
                                                    onClick={() => onChangeVisibility(item)}
                                                    style={{ color: "red" }}
                                                >
                                                    <i className={`bx ${item.IS_ACTIVE ? 'bx-trash' : 'bx-undo'}`} />
                                                </a>
                                            </li>
                                            
                                        <li className="list-inline-item px-2"><AdminDeleteButton resource="scheduleCategory" entryId={item.ID} label="scheduleCategory" /></li>
                                        </ul>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="7" className="text-center">No Categories found.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            <Paginations
                limit={limit}
                totalCount={total}
                range={5}
                currentPage={page}
                onPageChange={setCurrentPage}
            />
        </>
    );
};

export default withRouter(CategoryList);
